export const new_year_decoration_set = {
  product_id: "11",
  grid_type: "1",
  cover_image: "/1.jpg",
  media: ["1.jpg", "2.jpg", "3.jpg", "4.jpg"],
  product_name: "Neujahrsferien-Set",
  product_price: 83.0,
  product_slug: "new-year-decoration-set",
  short_description: "Das Neujahrsferien-Set vereint elegante Weihnachtsbaum- und Schneemannfiguren aus hochwertigem Acrylglas mit diamantgeschliffenen Rändern. Diese stilvolle Kollektion verleiht jeder Festtagsdekoration eine edle Note und sorgt für ein festliches Ambiente – perfekt für Zuhause oder das Büro.",
  description: `
  Wir stellen vor: das „Neujahrsferien-Set ".
  <br><br>
  Erleben Sie die Festtagsstimmung der Weihnachtszeit mit unserem exklusiven „New Year Holiday Set". Diese kuratierte Kollektion vereint eine Reihe exquisiter Kreationen, die Ihre festliche Dekoration aufwerten und ein Festtagsambiente schaffen.
  <br><br>
  Jedes Stück in diesem Set verkörpert außergewöhnliche Handwerkskunst und modernes Design. „Christmas S", „Christmas L" und „Christmas XL" verleihen Ihrer Feiertagsdekoration einen eleganten und festlichen Touch, „Schneemann L" und „Schneemann XL" bestechen durch ihre charmante und zeitlose Ausstrahlung.
  <br><br>
  Mit dem „Neujahrsferien-Set" haben Sie das perfekte Ensemble, um Ihr Zuhause oder Ihr Büro in eine Oase der Festtagsstimmung zu verwandeln. Diese handgefertigten Plexiglas-Kreationen sind vielseitig und elegant und fügen sich mühelos in jede Umgebung ein.
  <br><br>
  Ganz gleich, ob Sie mit der Familie feiern, ein Treffen mit Freunden planen oder einfach nur die Freude an der Jahreszeit genießen möchten, das „Neujahrsferien- Set" schafft die Voraussetzungen für unvergessliche Erinnerungen und eine gehobene Feiertagsdekoration. Begrüßen Sie das neue Jahr mit Stil und Raffinesse, dank dieser außergewöhnlichen Kollektion.
  <br><br>
  <h6> PRODUKTPFLEGE </h6>
  Um das makellose Aussehen Ihres „Neujahrsferien-Sets“ zu erhalten, verwenden Sie ein weiches, trockenes Tuch, um Staub zu entfernen, der sich im Laufe der Zeit ansammeln kann. So sieht Ihr Neujahrsferien-Set am besten aus und behält seine transparente Brillanz.
  <br><br>
  Wenn Sie diese Pflegerichtlinien befolgen, können Sie sicherstellen, dass Ihr "Neujahrsferien-Set" weiterhin glänzt und Ihre Inneneinrichtung über Jahre hinweg bereichert.
  `,
  specifications: {
    rows: [
      { name: "Material", value: "Hochwertiges Acrylglas" },
      { name: "Abmessungen : Weihnachtsbaum XL", value: "21.7cm x 9.9cm x 1cm" },
      { name: "Abmessungen : Weihnachtsbaum L", value: "14,5 cm x 10,8 cm x 1 cm" },
      { name: "Abmessungen : Weihnachtsbaum S", value: "9,7cm x 4,5cm x 1cm" },
      { name: "Abmessungen : Schneemann XL", value: "7,9cm x 4,3cm x 1cm" },
      { name: "Abmessungen : Schneemann L", value: "6cm x 3,4cm x 1cm" },
      { name: "Gewicht", value: "127 Gramm + 93 Gramm + 27 Gramm + 29 Gramm + 16 Gramm = 292 Gramm Set" },
      { name: "Farbe", value: "Transparent" },
      { name: "Ränder", value: "Diamantgeschliffen" },
    ],
    description: `Diese Angaben unterstreichen die hochwertige Qualität und Präzision des Produkts und machen potenziellen Kunden deutlich, was sie in Bezug auf Material, Größe, Gewicht, Farbe und Ausführung erwarten können.`,
  },
  category: "Table",
  title_color: "#ffffff",
  subtitle_color: "#999999",
  price_color: "#ffffff"
};
